module.exports = __webpack_public_path__ + "static/media/Kunal.e5194877.jpeg";